<template>
  <div class="ArticlesContent_right">
    <div class="ArticlesContent_right_link">
      <div class="ArticlesContent_right_link_box">
        <p class="tit" :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">{{$t('Articles.Like')}}</p>

        <ul v-if="relatedNews">
          <li   v-for="(item,index) in relatedNews" :key="index" @click="toArticles(item.id)">
            <div :class="[language == 'zh'?'zhFamilytitle':'enfamilytitle']">{{item.title}}</div>
            <div class="img_box">
                <img :src="`${GLOBAL.imageUrl}${item.icon}`" alt />
            </div>
          
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMixin } from "@/util/mixin";
export default {
  props: ["relatedNews"],
 mixins: [mapMixin],
  mounted() {},
  methods: {
    toArticles(id) {
      this.$router.push(`/articles?id=${id}`);
    }
  }
};
</script>

<style lang="scss" scoped>
.ArticlesContent_right {
  margin-left: 20px;
  width: 320px;
  // margin: auto;
  img {
    width: 100%;
  }
  .ArticlesContent_right_link {
    background: #fff;
    background-size: 100% 4px;
    border-radius: 4px;
    box-shadow: 0px 2px 4px #d8d8d8;
    border: 1px solid #d8d8d8;
    .ArticlesContent_right_link_box {
      padding:10px 0px;
      overflow: hidden;
      background: url("../../../assets/image/Public/colorBar.png") no-repeat;
      // background: #fff;
      .tit {
        padding-left: 10px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(22, 72, 109, 1);
      }
      ul {
        padding: 0 10px;
        li {
          padding: 8px 10px;
          font-size: 14px;
          border-bottom: 1px solid #d8d8d8;
          margin-top: 10px;
          border-radius: 4px;
           transition: .2s ease-in;
          &:hover{
            transition: .2s ease-in;
            background: #ececec;
          }
           &:hover img{
            transition: .2s ease-in;
            transform: scale(1.1)
          }
          //    margin-bottom: 30px;
          div {
            font-weight: 600;
            line-height: 20px;
            margin-bottom: 10px;
          }
          .img_box{
              overflow: hidden;
        width: 280px;
          height: 160px;
                img {
            
                 transition: .2s ease-in;
      
        object-fit: cover;
      
        height: 100%;
        width: 100%;
        // margin-bottom: 30px;
      }
          }
          
        }
      }
  
    }
  }
  .label {
    background: #fff;
    background-size: 100% 4px;
    border-radius: 4px;
    box-shadow: 0px 2px 4px #d8d8d8;
    border: 1px solid #d8d8d8;
    margin-top: 20px;
    .label_box {
      padding: 20px;
      overflow: hidden;
      background: url("../../../assets/image/Public/colorBar.png") no-repeat;

      // background: #fff;
      .tit {
        font-size: 16px;
        font-weight: 600;
        color: rgba(22, 72, 109, 1);
      }
      ul {
        li {
          background: rgba(234, 234, 234, 1);
          display: inline-block;
          margin-right: 10px;
          margin-top: 10px;
          padding: 2px 14px;
          font-size: 14px;
          color: #999;
          border-radius: 20px;
        }
      }
    }
  }
}
</style>